export const API_URL = import.meta.env.VITE_API_URL || ''
export const BASE_PATH = '/api'
